import { render, staticRenderFns } from "./PhotosSourceLocationsSettings.vue?vue&type=template&id=5fda3c0e&scoped=true"
import script from "./PhotosSourceLocationsSettings.vue?vue&type=script&lang=js"
export * from "./PhotosSourceLocationsSettings.vue?vue&type=script&lang=js"
import style0 from "./PhotosSourceLocationsSettings.vue?vue&type=style&index=0&id=5fda3c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda3c0e",
  null
  
)

export default component.exports